// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import * as profileActions from
  '../../pages/account/components/AccountTab/components/MyProfile/store/actions';
import { getPayment } from
  '../../pages/account/components/AccountTab/components/MyProfile/store/selectors';
import Input from '../Input/Input';
import styles from './styles';

class BankTransferForm extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    requestPayment: PropTypes.func,
    payment: PropTypes.object,
    changeFieldPayment: PropTypes.func,
  };

  componentDidMount() {
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    this.props.requestPayment(id, token);
  }

  onChangeInput = (value, name) => {
    this.props.changeFieldPayment(value, name);
  };

  static defaultProps = {
    classes: {},
    requestPayment: () => { },
    payment: {},
    changeFieldPayment: () => { },
  };

  render() {
    const { classes } = this.props;

    const AccountNameProps = {
      label: 'Account name:',
      name: 'AccountName',
      value: this.props.payment.AccountName,
      onChange: this.onChangeInput,
    };
    const SortCodeProps = {
      label: 'Sort Code:',
      name: 'SortCode',
      maxLength: 6,
      value: this.props.payment.SortCode,
      onChange: this.onChangeInput,
    };

    const AccountNumberProps = {
      label: 'Account Number:',
      name: 'AccountNumber',
      maxLength: 8,
      value: this.props.payment.AccountNumber,
      onChange: this.onChangeInput,
    };

    return (
      <MediaQuery minWidth={500}>
        {matches => (matches
          ? (
            <div className={classes.marginTop}>
              <Input {...AccountNameProps} width={400} />
              <div className={classes.inputsRow}>
                <Input {...SortCodeProps} width={180} />
                <Input {...AccountNumberProps} width={180} />
              </div>
            </div>)
          : (
            <div className={classNames(classes.mobileInputsContainer, classes.marginTop)}>
              <Input {...AccountNameProps} />
              <Input {...SortCodeProps} />
              <Input {...AccountNumberProps} />
            </div>))}
      </MediaQuery>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    payment: getPayment(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestPayment: (id, token) => dispatch(profileActions.requestProfile(id, token)),
    changeFieldPayment: (value, name) => dispatch(profileActions.changeFieldPayment(value, name)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(BankTransferForm));
